import { STATEMENT } from "@/config/site";

export const Statement = () => (
  <section className="relative bg-forest text-ivory py-24 lg:py-36 overflow-hidden grain" data-testid="statement-section">
    <div className="container-ph relative">
      <div className="reveal max-w-4xl">
        <p className="eyebrow">{STATEMENT.kicker}</p>
        <p className="mt-6 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.15] font-medium" data-testid="statement-big-text">{STATEMENT.big}</p>
        <span className="gold-line my-8" />
        <p className="text-base sm:text-lg text-ivory/80 leading-relaxed max-w-2xl">{STATEMENT.text}</p>
      </div>
    </div>
  </section>
);
